import { useEffect, useState } from 'react';

/**
 * Hook para escutar transições do container e forçar resize e fitBounds.
 * @param {React.RefObject} mapRef Ref da instância Leaflet
 * @param {React.RefObject} boxRef Ref do container do mapa
 * @returns {number} contador de gatilhos de transição
 */
export default function useMapAnimationFix(mapRef, boxRef) {
  const [counter, setCounter] = useState(0);
  useEffect(() => {
    const box = boxRef.current;
    if (!box) return;
    const handleTransitionEnd = (e) => {
      if (e.propertyName === 'flex-basis') {
        window.dispatchEvent(new Event('resize'));
        if (mapRef.current && mapRef.current.invalidateSize) {
          mapRef.current.invalidateSize();
        }
        setCounter((v) => v + 1);
      }
    };
    box.addEventListener('transitionend', handleTransitionEnd);
    return () => box.removeEventListener('transitionend', handleTransitionEnd);
  }, [boxRef, mapRef]);
  return counter;
}
